import { application } from "./application";

const modules = import.meta.glob("./*_controller.js", { eager: true });
for (const path in modules) {
  const name = path.match(/\.\/(.+)_controller\.js$/)[1].replace(/_/g, "-");
  application.register(name, modules[path].default);
}

export { application };
